import { Tabs } from "antd";
import { ConfigTab } from "./ConfigTab";
import { DesignTab } from "./DesignTab";
import DataTab from "./DataTab";
import type { ColumnOption } from "@/components/VivoPlots/types";

interface ModalTabProps {
  setters: any;
  getters: any;
  columnOptions: ColumnOption[];
  columnsTitleCreator: (column: string) => string;
  metadata: any;
  globalFilters: any;
  defaultActiveKey?: string;
}

export const ModalTab = ({
  setters,
  getters,
  columnOptions,
  columnsTitleCreator,
  metadata,
  globalFilters,
  defaultActiveKey = "config",
}: ModalTabProps) => {
  return (
    <div className="flex-1 min-h-0 flex flex-col overflow-hidden">
      <Tabs
        className="modal-tab flex-1 min-h-0 flex flex-col"
        defaultActiveKey={defaultActiveKey}
        renderTabBar={(props, DefaultTabBar) => (
          <div className="sticky top-0 z-10 bg-white pr-4">
            <DefaultTabBar {...props} />
          </div>
        )}
        items={[
          {
            label: "Configs",
            key: "config",
            children: (
              <ConfigTab
                columnsTitleCreator={columnsTitleCreator}
                setters={setters}
                getters={getters}
                columnOptions={columnOptions}
              />
            ),
          },
          {
            label: "Design",
            key: "design",
            children: <DesignTab setters={setters} getters={getters} />,
          },
          {
            label: "Data",
            key: "data",
            children: (
              <DataTab
                globalFilters={globalFilters}
                metadata={metadata}
                columnOptions={columnOptions}
                onFiltersChange={setters.setPlotFilters}
                plotFilters={getters.plotFilters}
                columnsTitleCreator={columnsTitleCreator}
              />
            ),
          },
        ]}
      />
    </div>
  );
};
